import { Home, Database, MapPin, Building2, Users, MessageCircle, Gamepad, Music, Newspaper, Store, Upload, Edit, Info, History } from 'lucide-react';
import type { MenuItem } from '../types/navigation';

export const mainMenuItems: MenuItem[] = [
  {
    name: 'Home',
    path: '/',
    icon: Home
  },
  {
    name: 'Database',
    path: '/database',
    icon: Database
  },
  {
    name: 'Map',
    path: '/map',
    icon: MapPin
  },
  {
    name: 'Media',
    icon: Gamepad,
    submenu: [
      { 
        name: 'Ranking Animatronics',
        path: '/ranking-game'
      },
      {
        name: 'Evolution of Animatronics',
        path: '/evolution'
      },
      {
        name: 'Yeti Escape',
        path: '/games/yeti-escape'
      },
      {
        name: 'Songs & Lyric Videos',
        path: '/media/songs'
      }
    ]
  },
  {
    name: 'Community',
    icon: Users,
    submenu: [
      { 
        name: 'Blog',
        path: '/community/blog'
      },
      {
        name: 'Comment Hub',
        path: '/community/comments'
      },
      {
        name: 'Submit New Animatronic',
        path: '/community/submit-new'
      },
      {
        name: 'Edit Existing Animatronic',
        path: '/community/edit-media'
      },
      {
        name: 'Store',
        path: '/community/store'
      }
    ]
  },
  {
    name: 'Directory',
    path: '/suppliers/directory',
    icon: Building2
  },
  {
    name: 'Contact',
    icon: MessageCircle,
    submenu: [
      { name: 'General Inquiries', path: '/contact' },
      { name: 'About Us', path: '/about' },
      { name: 'Partner with Us', path: '/advertising' }
    ]
  }
];

// Admin menu items
export const adminMenuItems: MenuItem[] = [
  {
    name: 'Admin',
    path: '/admin',
    icon: Info,
    requiresAdmin: true
  }
];